import {
  Clock, AlertCircle, CheckCircle, XCircle, Shield, AlertTriangle,
  FileText, Star
} from 'lucide-react';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const STATUS_CONFIG = {
  actif: { 
    label: 'Actif', 
    color: 'bg-emerald-600 text-white border-emerald-700',
    icon: CheckCircle,
    dot: 'bg-emerald-500'
  },
  en_attente: { 
    label: 'En attente', 
    color: 'bg-amber-500 text-white border-amber-600',
    icon: Clock,
    dot: 'bg-amber-500'
  },
  en_attente_connexion: { 
    label: 'En attente', 
    color: 'bg-amber-500 text-white border-amber-600',
    icon: Clock,
    dot: 'bg-amber-500'
  },
  pending: { 
    label: 'En attente', 
    color: 'bg-amber-500 text-white border-amber-600',
    icon: Clock,
    dot: 'bg-amber-500'
  },
  inactif: { 
    label: 'Inactif', 
    color: 'bg-gray-500 text-white border-gray-600',
    icon: XCircle,
    dot: 'bg-gray-500'
  },
  suspendu: { 
    label: 'Suspendu', 
    color: 'bg-red-600 text-white border-red-700',
    icon: AlertCircle,
    dot: 'bg-red-500'
  }
};

export const RCDS_CONFIG = {
  actif: { 
    label: 'RCDS Actif', 
    color: 'bg-gradient-to-r from-emerald-500 to-green-500 text-white border-emerald-600',
    icon: Shield,
    description: 'Couverture active'
  },
  a_renouveler: { 
    label: 'A renouveler', 
    color: 'bg-gradient-to-r from-amber-500 to-orange-500 text-white border-amber-600',
    icon: AlertTriangle,
    description: 'Couverture expire bientot'
  },
  expire: { 
    label: 'Expire', 
    color: 'bg-gradient-to-r from-red-500 to-rose-600 text-white border-red-600',
    icon: XCircle,
    description: 'Couverture expiree'
  },
  en_cours: { 
    label: 'RCDS en cours', 
    color: 'bg-blue-600 text-white border-blue-700',
    icon: Clock,
    description: 'Souscription en cours'
  },
  non_couvert: { 
    label: 'Non couvert', 
    color: 'bg-gray-400 text-white border-gray-500',
    icon: null,
    description: 'Aucune couverture'
  }
};

export const FTPE_CONFIG = {
  adherent: { 
    label: 'Adherent', 
    color: 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white border-blue-600',
    icon: Star,
    description: 'Adherent actif'
  },
  actif: { 
    label: 'Adherent', 
    color: 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white border-blue-600',
    icon: Star,
    description: 'Adherent actif'
  },
  signed: { 
    label: 'Adherent', 
    color: 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white border-blue-600',
    icon: Star,
    description: 'Adherent - Bulletin signe'
  },
  completed: { 
    label: 'Adherent', 
    color: 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white border-blue-600',
    icon: Star,
    description: 'Adherent actif'
  },
  active: { 
    label: 'Adherent', 
    color: 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white border-blue-600',
    icon: Star,
    description: 'Adherent actif'
  },
  a_renouveler: { 
    label: 'A renouveler', 
    color: 'bg-gradient-to-r from-yellow-500 to-amber-500 text-white border-yellow-600',
    icon: AlertTriangle,
    description: 'Adhesion expire bientot'
  },
  expire: { 
    label: 'Expire', 
    color: 'bg-gradient-to-r from-red-500 to-rose-600 text-white border-red-600',
    icon: XCircle,
    description: 'Adhesion expiree'
  },
  en_attente: { 
    label: 'En attente', 
    color: 'bg-cyan-600 text-white border-cyan-700',
    icon: Clock,
    description: 'Adhesion en cours'
  },
  non_adherent: { 
    label: 'Non adherent', 
    color: 'bg-gray-400 text-white border-gray-500',
    icon: null,
    description: ''
  }
};

export const DOS_CONFIG = {
  souscrit: { 
    label: 'Souscrit', 
    color: 'bg-gradient-to-r from-emerald-500 to-green-600 text-white border-emerald-600',
    icon: CheckCircle,
    description: 'Souscription DOS validee'
  },
  paye: { 
    label: 'Paye', 
    color: 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white border-emerald-700',
    icon: CheckCircle,
    description: 'Paiement DOS recu'
  },
  en_attente: { 
    label: 'En attente', 
    color: 'bg-gradient-to-r from-amber-500 to-orange-500 text-white border-amber-600',
    icon: Clock,
    description: 'Paiement en attente'
  },
  brouillon: { 
    label: 'Brouillon', 
    color: 'bg-slate-500 text-white border-slate-600',
    icon: FileText,
    description: 'Souscription en cours'
  },
  non_souscrit: { 
    label: 'Non souscrit', 
    color: 'bg-gray-400 text-white border-gray-500',
    icon: null,
    description: ''
  }
};
